import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d962d3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "tabs-right" }

import { toRefs } from "vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null,
    tabs: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "update:modelValue", value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: string;
  tabs: string[];
}

const { t } = useI18n();


const { modelValue } = toRefs(props);

const update = (tab: string) => {
  emits("update:modelValue", tab);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["tab-item", { 'active-tab-item': tab === _unref(modelValue) }]),
        key: tab,
        onClick: ($event: any) => (update(tab))
      }, _toDisplayString(_unref(t)(tab)), 11, _hoisted_2))
    }), 128)),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})